import ApiUtils from 'api/ApiUtils';
import React, {useEffect, useState} from 'react';
import {Card, Col, Row} from 'react-bootstrap';
import {Link} from 'react-router-dom'; // Import Link from react-router-dom
import CountUp from 'react-countup';
import {toast} from 'react-toastify';
import NewUserRegistraion from './NewUserRegistraion';
import Chart from 'react-apexcharts';
import NewVenueRegistraion from './NewVenueRegistraion';
import GuestListByVenue from './GuestListByVenue';
import MostPopularEvents from './MostPopularEvents';
import ReferralConversionRate from './ReferralConversionRate';
import VenuePerformance from './VenuePerformance';
import ReportUserAnalyticsDemographics from './ReportUserAnalyticsDemographics';
import ReportUserAnalyticsRetention from './ReportUserAnalyticsRetention';
import ReportUserAnalyticsEngagement from './ReportUserAnalyticsEngagement ';
import EventEngagement from './EventEngagement';

interface WidgetsProps {
  id: number;
  name: string;
  amount?: number;
  decimal?: number;
  icon: string;
  iconColor: string;
  redirectTo: string;
}
interface DashboardCount {
  total_user: number;
  upcoming_event: number;
  referrals_count: number;
  active_user: number;
  inactive_user: number;
  total_not_signed_venue: number;
  total_pending_venue: number;
  total_signed_venue: number;
  // deliveredOrder: number;
  // deliveryPersonAssignOrder: number;
  // pendingOrder: number;
}
const Widgets = (): any => {
  // const [cardData, setCardData]: any = useState();

  // const fetchDasboardData = async (): Promise<void> => {
  //   try {
  //     const resp: any = await ApiUtils.getDasbordData('date_filter=');
  //     setCardData(resp?.data);
  //   } catch (error) {
  //     console.error('Error fetching dashboard data:', error);
  //   }
  // };
  const [dashBoardCount, setDashBoardCount] = useState<DashboardCount>();
  console.log('🚀 ~ Widgets ~ dashBoardCount:', dashBoardCount);

  const getDashBordCount = async (): Promise<void> => {
    try {
      const response = await ApiUtils.getDashBoardCount();
      setDashBoardCount((response as any).data);
    } catch (error: any) {
      toast.error(error.message);
    }
  };
  useEffect(() => {
    void getDashBordCount();
  }, []);

  // useEffect(() => {
  //   void fetchDasboardData();
  // }, []);

  const widgetsData: WidgetsProps[] = [
    {
      id: 1,
      name: 'TOTAL Registered USERS',
      amount: dashBoardCount?.total_user,
      icon: 'ph-user',
      iconColor: 'secondary',
      redirectTo: '#',
    },
    {
      id: 2,
      name: 'UPCOMING EVENTS',
      amount: dashBoardCount?.upcoming_event,
      icon: 'bi bi-hourglass-split',
      iconColor: 'info',
      redirectTo: '#',
    },
    {
      id: 3,
      name: 'TOTAL REFERRALS SENT',
      amount: dashBoardCount?.referrals_count,
      icon: 'bi bi-link-45deg',
      iconColor: 'warning',
      redirectTo: '#',
    },
    // {
    //   id: 4,
    //   name: 'TOTAL PRODUCTS',
    //   amount: cardData?.product,
    //   icon: 'bi bi-box',
    //   iconColor: 'primary',
    //   redirectTo: '/products',
    // },
    // {
    //   id: 5,
    //   name: 'PENDING ORDER',
    //   amount: dashBoardCount?.pendingOrder,
    //   icon: 'bi bi-hourglass-split',
    //   iconColor: 'secondary',
    //   redirectTo: '/order-list?status=PENDING',
    // },
    // {
    //   id: 7,
    //   name: 'CANCELLED ORDER',
    //   amount: dashBoardCount?.cancelOrder,
    //   icon: 'bi bi-trash',
    //   iconColor: 'danger',
    //   redirectTo: '/order-list?status=CANCELED',
    // },
  ];

  const optionsActiveInactive: any = {
    chart: {
      height: 700,
      // type: 'donut',
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    stroke: {
      curve: 'straight',
    },
    title: {
      text: `Active/In Active Users`,
      align: 'left',
    },
    grid: {
      row: {
        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
        opacity: 0.5,
      },
    },
    labels: ['Active', 'In Active'],
    legend: {
      position: 'bottom', // This places the legend at the bottom
      horizontalAlign: 'center', // Centers the legend items
      floating: false, // Set to false to avoid floating over the chart
    },
  };

  const optionsVenue: any = {
    chart: {
      height: 700,
      // type: 'donut',
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    stroke: {
      curve: 'straight',
    },
    title: {
      text: `Total Not Partner Venue, Pending Venue , Partner Venue`,
      align: 'left',
    },
    grid: {
      row: {
        colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
        opacity: 0.5,
      },
    },
    legend: {
      position: 'bottom', // This places the legend at the bottom
      horizontalAlign: 'center', // Centers the legend items
      floating: false, // Set to false to avoid floating over the chart
    },
    // series: [
    //   dashBoardCount?.total_not_signed_venue,
    //   dashBoardCount?.total_pending_venue,
    //   dashBoardCount?.total_signed_venue,
    // ],
    labels: ['Not Partner', 'Pending', 'Partner'],
  };

  return (
    <>
      <Row>
        {widgetsData?.map((item: any, key: number) => (
          <Col md={6} lg={4} sm={12} key={key}>
            {/* Conditionally render Link based on the widget id */}
            {item.id === 3 ? (
              <Link to={item.redirectTo} style={{textDecoration: 'none'}}>
                <Card className="card-animate">
                  <Card.Body>
                    <div className="d-flex justify-content-between gap-1">
                      <div
                        className={
                          'vr rounded bg-' + item.iconColor + ' opacity-50'
                        }
                        style={{width: '4px'}}></div>
                      <div className="flex-grow-1 ms-3">
                        <p
                          data-testid="widget-title"
                          className="text-uppercase fw-medium text-muted fs-14 ">
                          {item.name}
                        </p>
                        <h4 className="fs-22 fw-semibold mb-3">
                          {(item.decimal as boolean) ? '$' : ''}
                          <span
                            className="counter-value"
                            data-target="98851.35"
                            data-testid="widget-amount">
                            <CountUp
                              start={0}
                              end={item.amount}
                              separator=","
                              decimals={
                                (item.decimal as boolean) ? 2 : undefined
                              }
                            />
                          </span>
                        </h4>
                      </div>
                      <div className="avatar-sm flex-shrink-0">
                        <span
                          className={
                            'avatar-title bg-' +
                            item.iconColor +
                            '-subtle text-' +
                            item.iconColor +
                            ' rounded fs-3'
                          }>
                          <i className={item.icon}></i>
                        </span>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Link>
            ) : (
              // Render without Link for other widgets
              <Link to={item.redirectTo} style={{textDecoration: 'none'}}>
                <Card className="card-animate">
                  <Card.Body>
                    <div className="d-flex justify-content-between gap-1">
                      <div
                        className={
                          'vr rounded bg-' + item.iconColor + ' opacity-50'
                        }
                        style={{width: '4px'}}></div>
                      <div className="flex-grow-1 ms-3">
                        <p
                          data-testid="widget-title"
                          className="text-uppercase fw-medium text-muted fs-14 ">
                          {item.name}
                        </p>
                        <h4 className="fs-22 fw-semibold mb-3">
                          {(item.decimal as boolean) ? '$' : ''}
                          <span
                            className="counter-value"
                            data-target="98851.35"
                            data-testid="widget-amount">
                            <CountUp
                              start={0}
                              end={item.amount}
                              separator=","
                              decimals={
                                (item.decimal as boolean) ? 2 : undefined
                              }
                            />
                          </span>
                        </h4>
                      </div>
                      <div className="avatar-sm flex-shrink-0">
                        <span
                          className={
                            'avatar-title bg-' +
                            item.iconColor +
                            '-subtle text-' +
                            item.iconColor +
                            ' rounded fs-3'
                          }>
                          <i className={item.icon}></i>
                        </span>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              </Link>
            )}
          </Col>
        ))}
      </Row>

      <Row className="g-3 text-center">
        <Col xxl={8}>
          <NewUserRegistraion />
        </Col>
        <Col xxl={4}>
          <Card>
            <Card.Header className="align-items-center d-flex">
              <h4 className="card-title mb-2 flex-grow-1 text-start mt-3">
                Number of users Active / In Active
              </h4>
            </Card.Header>
            <Card.Body className="pb1-5">
              <Chart
                options={optionsActiveInactive}
                series={
                  dashBoardCount !== undefined
                    ? [
                        dashBoardCount?.active_user,
                        dashBoardCount?.inactive_user,
                      ]
                    : []
                }
                type="donut"
                height="450"
                className="apex-charts apex-charts-dashboard"
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="g-3 text-center">
        <Col xxl={4}>
          <Card>
            <Card.Header className="align-items-center d-flex">
              <h4 className="card-title mb-2 flex-grow-1 text-start mt-3">
                Total Not Partner Venue, Pending Venue , Partner Venue
              </h4>
            </Card.Header>
            <Card.Body className="pb1-5">
              <Chart
                options={optionsVenue}
                series={
                  dashBoardCount !== undefined
                    ? [
                        dashBoardCount?.total_not_signed_venue,
                        dashBoardCount?.total_pending_venue,
                        dashBoardCount?.total_signed_venue,
                      ]
                    : []
                }
                type="donut"
                height="440"
                className="apex-charts apex-charts-dashboard1"
              />
            </Card.Body>
          </Card>
        </Col>

        <Col xxl={8}>
          <NewVenueRegistraion />
        </Col>
      </Row>

      <Row className="g-3 text-center">
        <Col xxl={12}>
          <GuestListByVenue />
        </Col>
      </Row>

      <Row className="g-3 text-center">
        <Col xxl={6}>
          <MostPopularEvents />
        </Col>
        <Col xxl={6}>
          <ReferralConversionRate dashBoardCount={dashBoardCount} />
        </Col>
      </Row>

      <Row className="g-3 text-center">
        <Col xxl={12}>
          <VenuePerformance />
        </Col>
      </Row>

      <Row className="g-3 text-center">
        <Col xxl={12}>
          <ReportUserAnalyticsDemographics dashBoardCount={dashBoardCount} />
        </Col>
      </Row>

      <Row className="g-3 text-center">
        <Col xxl={6}>
          <ReportUserAnalyticsRetention />
        </Col>
        <Col xxl={6}>
          <ReportUserAnalyticsEngagement />
        </Col>
      </Row>

      <Row className="g-3 text-center">
        <Col xxl={12}>
          <EventEngagement />
        </Col>
      </Row>
    </>
  );
};

export default Widgets;
